export default "__VITE_ASSET__edd43dbb__"